<template>
  <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="768" id="claim-dialog" class="edit-dialog">
    <v-card flat class="drawer-card">
      <v-card-title>
        <div class="title">発注・支払伝票の作成</div>
      </v-card-title>
      <v-card-text class="print-sheet scroll-content">

        <v-form v-model="valid">
          <v-row no-gutters>
            <v-col cols="6" class="pa-2">
              <v-text-field
                ref="no"
                label="伝票No"
                v-model="editedItem.no"
                hint="伝票Noが指定されない場合は自動採番されます"
                outlined hide-details="auto" persistent-hint>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" class="pa-2">
              <v-text-field
                ref="title"
                label="件名"
                v-model="editedItem.title"
                :rules="[rules.required]"
                class="required"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pa-2">
              <v-combobox
                ref="corporate"
                label="支払元"
                v-model="editedItem.corporateID"
                :items="corporateItems"
                :rules="[rules.required]"
                class="required"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('corporate')"
                readonly outlined hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="12" class="pa-2">
              <v-combobox
                ref="kind"
                label="科目"
                v-model="editedItem.kind"
                :items="kinds"
                :rules="[rules.required]"
                class="required"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('kind')"
                outlined hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="12" class="pa-2">
              <v-combobox
                ref="customer"
                label="客先"
                v-model="editedItem.customerID"
                :items="customers"
                :rules="[rules.required]"
                class="required"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('customer', true)"
                readonly outlined hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="orderDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="orderDate"
                    label="発注日"
                    v-model="editedItem.orderDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.orderDate" @input="orderDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="claimDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="claimDate"
                    label="請求日"
                    v-model="editedItem.claimDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.claimDate" @input="claimDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="fixedDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="fixedDate"
                    label="支払期日"
                    v-model="editedItem.fixedDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.fixedDate" @input="fixedDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="paymentDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="paymentDate"
                    label="支払日"
                    v-model="editedItem.paymentDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.paymentDate" @input="paymentDate = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" class="pa-2">
              <v-text-field
                ref="amount"
                label="金額"
                type="number"
                v-model="editedItem.amount"
                :rules="[rules.required, rules.integer, rules.min0]"
                class="required"
                :append-icon="lockAmount ? 'fas fa-lock' : 'fas fa-pencil-alt'"
                :readonly="lockAmount"
                @click:append="toggleLockAmount"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="3" class="pa-2">
              <v-text-field
                ref="tax"
                label="消費税"
                type="number"
                min="0"
                max="100"
                v-model="editedItem.tax"
                :rules="[rules.integer, rules.min0, rules.max100]"
                append-icon="fas fa-percentage"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="3" class="pa-2">
              <toggle-button
                v-model="editedItem.taxCalc"
                :labels="{checked: '切り上げ', unchecked: '切り捨て'}"
                color="#0277bd"
                :value="editedItem.taxCalc"
                :sync="true"
                :width="150" :height="55" :font-size="14">
              </toggle-button>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-combobox
                ref="payment"
                label="支払方法"
                v-model="editedItem.payment"
                :items="payment"
                :rules="[rules.required]"
                class="required"
                outlined hide-details="auto">
              </v-combobox>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" md="3" class="pa-2">
              <v-subheader>振込手数料</v-subheader>
              <toggle-button
                v-model="editedItem.commission"
                :labels="{checked: '必要', unchecked: '不要'}"
                color="#0277bd"
                :value="editedItem.commission"
                :sync="true"
                :width="90" :height="30" :font-size="14">
              </toggle-button>
            </v-col>
            <v-col cols="6" md="3" class="pa-2">
              <v-subheader>入金</v-subheader>
              <toggle-button
                v-model="editedItem.complete"
                :labels="{checked: '済', unchecked: '未'}"
                color="#0277bd"
                :value="editedItem.complete"
                :sync="true"
                :width="90" :height="30" :font-size="14">
              </toggle-button>
            </v-col>
          </v-row>
          <!-- 品目 -->
          <div class="section-title">品目</div>
          <div class="item-ctrl">
            <ul class="list-inline">
              <li class="px-1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed small v-bind="attrs" v-on="on" @click.stop="copy" :disabled="!isSelected" color="yellow">
                      <v-icon left>far fa-copy</v-icon>コピー
                    </v-btn>
                  </template>
                  <span>コピー</span>
                </v-tooltip>
              </li>
              <li class="px-1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed small v-bind="attrs" v-on="on" @click.stop="paste" :disabled="!clip" color="amber">
                      <v-icon left>far fa-clipboard</v-icon>貼り付け
                    </v-btn>
                  </template>
                  <span>貼り付け</span>
                </v-tooltip>
              </li>
            </ul>
          </div>
          <v-data-table
            :headers="itemHeaders"
            :items="editedItem.items"
            :loading="loading"
            hide-default-footer
            disable-pagination>
            <template v-slot:header.check="{}">
              <v-checkbox
                v-model="selectAll"
                @click.stop="selectAllCheck"
                dense></v-checkbox>
            </template>
            <template v-slot:body="{ items }">
              <draggable 
                v-model="editedItem.items" 
                tag="tbody" 
                handle=".handle"
                class="draggable-table"
                ghost-class="ghost">
                <tr v-for="(item, index) in items" :key="index">
                  <td>
                    <span class="handle">
                      <v-icon small>fas fa-bars</v-icon>
                    </span>
                  </td>
                  <td>
                    <v-checkbox
                      v-model="item.selected"
                      dense></v-checkbox>
                  </td>
                  <td class="py-2">
                    <v-row no-gutters>
                      <v-col cols="12" md="4" class="pa-2">
                        <v-text-field v-model="item.name" 
                          label="品名・品番"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="3" md="2" class="pa-2">
                        <v-text-field 
                          label="数量"
                          v-model="item.quantity" 
                          type="number"
                          min="1"
                          class="text-right"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="3" md="1" class="pa-2">
                        <v-text-field v-model="item.unit" 
                          label="単位"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="6" md="2" class="pa-2">
                        <v-text-field 
                          label="単価"
                          v-model="item.value" 
                          type="number"
                          class="text-right"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <template v-if="item.quantity && item.value">
                          <v-text-field 
                            :value="separate(item.quantity * item.value)" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </template>
                      </v-col>
                      <v-col cols="12" md="9" class="pa-2">
                        <v-text-field v-model="item.remarks" 
                          label="備考"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td>
                    <span @click="trash(index)">
                      <v-icon small>fas fa-times</v-icon>
                    </span>
                  </td>
                </tr>
              </draggable>
              <tbody>
                <tr class="table-footer">
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl">
                    <v-row no-gutters>
                      <v-col cols="12" md="9" class="pa-2">
                        <v-btn small text @click.stop="addRow">
                          <v-icon left>far fa-plus-square</v-icon>
                          行の追加
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <v-text-field 
                          label="小計"
                          :value="separate(subtotal)" class="text-right"
                          disabled dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td class="row-ctrl"></td>
                </tr>
                <tr class="table-footer">
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl">
                    <v-row no-gutters>
                      <v-col cols="12" md="9" class="pa-2"></v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <v-text-field 
                          label="消費税"
                          :value="separate(tax)" class="text-right"
                          disabled dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td class="row-ctrl"></td>
                </tr>
                <tr class="table-footer">
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl">
                    <v-row no-gutters>
                      <v-col cols="12" md="9" class="pa-2"></v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <v-text-field 
                          label="合計"
                          :value="separate(total)" class="text-right"
                          disabled dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td class="row-ctrl"></td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- 備考 -->
          <div class="section-title">その他</div>
          <v-row no-gutters>
            <v-col cols="12" class="pa-2">
              <Upload
                :file.sync="editedItem.pic"
                label="資料"
                @lightbox="lightboxFunc"
                accept="image/*,.pdf" />
            </v-col>
            <v-col cols="12" class="pa-2">
              <v-textarea
                ref="remarks"
                label="備考"
                v-model="editedItem.remarks"
                rows="5"
                outlined hide-details="auto">
              </v-textarea>
            </v-col>
          </v-row>

        </v-form>

      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
          <v-icon left>fas fa-save</v-icon>保存
        </v-btn>
        <PDFMake
          :param="editedItem"
          :corporate="corporate"
          :formatList="['発注書']"
          :loading="loading"
          :saving="saving"></PDFMake>
        <v-btn color="error" @click="remove" :loading="saving" v-if="editedItem.id" text x-large>
          <v-icon left>fas fa-trash-alt</v-icon>削除
        </v-btn>
        <v-btn @click="dialog = false" text x-large>
          <v-icon left>fas fa-times</v-icon>閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { 
  createPayment, updatePayment, deletePayment,
  createCustomer,
  createPaymentItem, updatePaymentItem, deletePaymentItem,
  createSequence, updateSequence } from '../graphql/mutations'
import { listAppOptions, listPaymentItems, getSequence } from '../graphql/queries'
import moment from 'moment'
import Upload from '@/components/Upload'
import draggable from 'vuedraggable'
import PDFMake from '@/components/PdfMake'

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      appOptions: {},
      itemHeaders: [
        { text: '', align: 'center', value: '', sortable: false, width: 30 },
        { text: '', align: 'center', value: 'check', sortable: false, width: 30 },
        { text: '', align: 'start', value: 'name', sortable: false },
        { text: '', align: 'center', value: '', sortable: false, width: 30 },
      ],
      orderDate: false,
      claimDate: false,
      fixedDate: false,
      paymentDate: false,
      saving: false,
      kinds: [
        '原価',
        '経費',
        '税金',
        'その他',
      ],
      origin: [],
      clip: false,
      selectAll: false,
      lockAmount: true,
    }
  },
  props: {
    editedItem: {
      type: Object,
      default: () => ({}),
    },
    corporates: {
      type: Array,
      default: () => ([]),
    },
    customers: {
      type: Array,
      default: () => ([]),
    },
    projectID: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mounted: async function() {
    //設定 query
    const appOptionQuery = await API.graphql(graphqlOperation(listAppOptions, { limit: 100 }))
    for (const row of appOptionQuery.data.listAppOptions.items) {
      this.appOptions[row.name] = row.value
    }
    //クリップボードの監視
    this.unwatch = this.$store.watch(
      (state, getters) => getters.itemsClip,
      (newValue, oldValue) => {
        if (newValue != oldValue) {
          if (newValue.length > 0) {
            this.clip = true
            this.myAlert('コピーしました', 'success')
          } else {
            this.clip = false
            this.myAlert('ペーストしました', 'success')
          }
        }
      }
    )
    this.resetForm()
  },
  beforeDestroy() {
    try {
      this.unwatch()
    } catch (e) {
      //
    }
  },
  computed: {
    form() {
      return {
        id: this.editedItem.id || null,
        no: this.editedItem.no || null,
        title: this.editedItem.title || null,
        kind: this.editedItem.kind || null,
        orderDate: this.editedItem.orderDate || null,
        claimDate: this.editedItem.claimDate || null,
        fixedDate: this.editedItem.fixedDate || null,
        paymentDate: this.editedItem.paymentDate || null,
        corporateID: this.editedItem.corporateID ? this.editedItem.corporateID.value: null,
        customerID: this.editedItem.customerID ? this.editedItem.customerID.value: null,
        payment: this.editedItem.payment || null,
        amount: this.editedItem.amount,
        tax: this.editedItem.tax || null,
        commission: this.editedItem.commission,
        complete: this.editedItem.complete,
        pic: this.editedItem.pic || null,
        remarks: this.editedItem.remarks || null,
      }
    },
    subtotal() {
      try {
        let val = 0
        for (const item of this.editedItem.items) {
          val += item.quantity * item.value
        }
        return val

      } catch (e) {
        return 0
      }
    },
    tax() {
      try {
        let val = this.subtotal
        let tax = this.editedItem.tax || 0

        if (this.editedItem.taxCalc === false) {
          // 切り捨て
          return Math.floor(val * (tax / 100))

        } else {
          // 切り上げ
          return Math.ceil(val * (tax / 100))
        }

      } catch (e) {
        return 0
      }
    },
    total() {
      const amount = this.subtotal + this.tax
      if (this.subtotal > 0 && this.tax > 0) {
        //this.editedItem.amount = amount
      }
      return amount
    },
    corporateItems() {
      const map = []
      for (const item of this.corporates) {
        map.push({
          text: item.name,
          value: item.id
        })
      }
      return map
    },
    corporate() {
      var map
      if (this.corporates.length > 0) {
        map = Object.assign({}, this.corporates[0])
        if (this.editedItem.corporateID) {
          map = Object.assign({}, 
            this.corporates.find(e => e.id === this.editedItem.corporateID.value)
          )
        }
      }
      return map
    },
    isSelected() {
      if (this.editedItem.items) {
        for (const item of this.editedItem.items) {
          if (item.selected) return true
        }
      }

      return false
    },
  },
  watch: {
    show(val) {
      this.dialog = val
    },
    async dialog(val) {
      //val || this.close()
      if (val) {
        if (this.editedItem.id) {
          this.loading = true
          /*
          if (this.editedItem.corporateID) {
            this.editedItem.corporateID = this.corporateItems.find(e => e.value === this.editedItem.corporateID)
          }
          if (this.editedItem.officeID) {
            this.editedItem.officeID = this.officeItems.find(e => e.value === this.editedItem.officeID)
          }
          if (this.editedItem.chargeID) {
            this.editedItem.chargeID = this.chargeItems.find(e => e.value === this.editedItem.chargeID)
          }
          */
          this.editedItem.tax = this.editedItem.tax || 0
          //品目の取得
          await this.getPaymentItems(this.editedItem.items, this.editedItem.id)

        } else {
          
          //消費税
          this.$set(this.editedItem, 'tax', this.appOptions.consumptionTax ? parseInt(this.appOptions.consumptionTax) : 10)
          //品目
          this.$set(this.editedItem, 'items', [])

          //オリジナルはなし
          this.origin = []
          //デフォルトで項目を1行生成
          this.addRow()
        }
      
      } else {
        this.close()
      }
    },
    total(val) {
      this.editedItem.amount = val
    },
  },
  methods: {
    async save() {
      try {
        this.saving = true
        const data = Object.assign({}, this.form)

        //伝票Noが指定されていなければ自動採番する
        if (!data.no) {
          data.no = await this.createOrderID()
          this.editedItem.no = data.no
        }

        //客先が追加された場合
        if (!data.customerID) {
          const customer = {
            name: this.editedItem.customerID,
            payment: ['銀行振込'],
          }
          const ret = await API.graphql(graphqlOperation(createCustomer, {input: customer}))
          this.log({ type: this.$route.name, text: '請求書にて [' + customer.name + '] を追加しました' })
          //追加した客先IDを設定
          data.customerID = ret.data.createCustomer.id
          this.editedItem.customerID = {
            text: customer.name,
            value: ret.data.createCustomer.id,
          }
        }

        //編集
        if (data.id) {
          await API.graphql(graphqlOperation(updatePayment, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.title + '] を更新しました' })
          this.myAlert(data.title + 'を更新しました', 'success')

        //新規
        } else {
          delete data.id
          const payment = await API.graphql(graphqlOperation(createPayment, {input: data}))
          this.editedItem.id = payment.data.createPayment.id
          this.log({ type: this.$route.name, text: '[' + data.title + '] を追加しました' })
          this.myAlert(data.title + 'を追加しました', 'success')
        }

        //品目の保存
        let cnt = 0
        for (const item of this.editedItem.items) {
          const model = this.getModel(item)
          model.sort = cnt++
          if (item.id) {
            await API.graphql(graphqlOperation(updatePaymentItem, {input: model}))
          } else {
            delete model.id
            const ret = await API.graphql(graphqlOperation(createPaymentItem, {input: model}))
            item.id = ret.data.createPaymentItem.id
          }
        }
        //オリジナルにのみ存在するものは削除
        for (const model of this.origin) {
          if (!this.editedItem.items.find(e => e.id === model.id)) {
            await API.graphql(graphqlOperation(deletePaymentItem, {
              input: { id: model.id }
            }))
          }
        }

        if (this.editedItem.docRegist) {
          this.$emit('docRegistComplete', this.editedItem.pic)
        }
        
        this.myAlert('発注・支払伝票を保存しました', 'success')
        this.saving = false

      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.title + 'を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deletePayment, {
            input: { id: this.editedItem.id }
          }))
          for (const item of this.editedItem.items) {
            if (!item.id) continue
            await API.graphql(graphqlOperation(deletePaymentItem, {
              input: { id: item.id }
            }))
          }
          this.log({ type: this.$route.name, text: '[' + this.editedItem.title + '] を削除しました' })
          this.myAlert(this.editedItem.title + 'を削除しました', 'success')
          this.dialog = false
        }
      } catch (error) {
        this.myAlert(error)
      }
    },
    //品目の取得
    async getPaymentItems(target, paymentID, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listPaymentItems, { 
        filter: {
          paymentID: { eq: paymentID }
        },
        limit: 100,
        nextToken: nextToken
      }))
      for (const row of query.data.listPaymentItems.items) {
        target.push(row)
      }
      if (query.data.listPaymentItems.nextToken) {
        this.getPaymentItems(target, paymentID, query.data.listPaymentItems.nextToken)
      } else {
        //オリジナルをコピーしておく
        this.origin = [...target]
        //作成日付降順でソート
        target.sort(function(a,b) {
          if (a.sort < b.sort) return -1
          if (a.sort > b.sort) return 1
          return 0
        })
        this.loading = false
      }
    },
    //品目
    getModel(item) {
      return {
        id: item.id || null,
        paymentID: this.editedItem.id || null,
        modelID: item.modelID || null,
        subModelID: item.modelID || null,
        name: item.name || null,
        quantity: item.quantity || null,
        unit: item.unit || null,
        value: item.value || null,
        remarks: item.remarks || null,
      }
    },
    //伝票Noの生成
    async createOrderID() {
      //let count = 1
      const name = 'ORDER_' + (this.appOptions.orderDateFormat ? moment().format(this.appOptions.orderDateFormat) : '')
      const tag = 'Order'

      //連番キーがあるか
      const find = await API.graphql(graphqlOperation(getSequence, {
        name: name,
        tag: tag,
      }))

      const data = {
        name: name,
        tag: tag,
        count: find.data.getSequence ? find.data.getSequence.count + 1 : 1,
      }

      if (find.data.getSequence) {
        await API.graphql(graphqlOperation(updateSequence, { input: data }))
      } else {
        await API.graphql(graphqlOperation(createSequence, { input: data }))
      }

      //伝票Noの生成
      const prefix = this.appOptions.orderPrefix || ''
      const dateFormat = this.appOptions.orderDateFormat ? moment().format(this.appOptions.orderDateFormat) : ''
      const noDigit = this.appOptions.orderNoDigit || null
      const digit = noDigit ? this.zeroPadding(data.count, parseInt(noDigit)) : data.count
      const orderID = prefix + dateFormat + digit

      return orderID
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.$emit('close')
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
        //スクロールリセット
        let container = document.getElementById('claim-dialog').getElementsByClassName('v-navigation-drawer__content')[0]
        container.scrollTop = 0
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
      this.editedItem.id = null
      this.editedItem.no = null
      this.editedItem.commission = true
      this.editedItem.complete = false
      this.editedItem.pic = null
      this.editedItem.docRegist = false
      //スクロールのリセット
      this.scrollReset()
    },
    //スクロールを戻す
    scrollReset() {
      let container = document.getElementsByClassName('scroll-content')[0]
      container.scrollTop = 0
    },
    //印刷
    print() {
      window.print();
    },
    //ゼロ埋め
    zeroPadding(num, len) {
      return (Array(len).join('0') + num).slice(-len)
    },
    //品目の追加
    addRow() {
      this.editedItem.items.push({
        name: null,
        quantity: null,
        unit: null,
        value: null,
        remarks: null,
      })
    },
    //品目の削除
    trash(index) {
      this.editedItem.items.splice(index, 1)
    },
    //全選択
    selectAllCheck() {
      for (const item of this.editedItem.items) {
         this.$set(item, 'selected', this.selectAll)
      }
    },
    //コピー
    copy() {
      if (this.editedItem.items.length > 0) {
        const map = []
        for (const item of this.editedItem.items) {
          if (item.selected) {
            map.push({
              modelID: item.modelID,
              name: item.name,
              quantity: item.quantity,
              subModelID: item.subModelID,
              unit: item.unit,
              value: item.value,
              remarks: item.remarks,
            })
          }
        }
        //クリップボードに保持
        this.$store.dispatch('updateItemsClip', map)
      }
    },
    //ペースト
    paste() {
      for (const item of this.$store.getters.itemsClip) {
        this.editedItem.items.push(item)
      }
      //クリップボードを消す
      this.$store.dispatch('updateItemsClip', [])
    },
    //金額ロックの解除
    toggleLockAmount() {
      this.lockAmount = !this.lockAmount
    },
  },
  components: {
    Upload,
    draggable,
    PDFMake,
  },
}
</script>

<style lang='scss' scoped>
.section-title {
  margin: 10px 0;
  padding: 5px 10px;
  font-weight: bold;
  background: #e1ecf3;
}
tbody {
  tr {
    &:hover {
      background: transparent !important;
    }
    &.ghost {
      opacity: 0.5 !important;
      background: #c8ebfb !important;
    }
    td {
      .handle {
        &:hover {
          cursor: move;
        }
      }
      
    }
  }
}
.table-footer {
  &:first-of-type td {
    border-top: thin solid rgba(0, 0, 0, 0.12);
  }
  &:hover {
    background: #FFF !important;
  }
  td {
    cursor: default !important;
    &.row-ctrl {
      vertical-align: top;
      padding-top: 10px;
      border-bottom: none !important;
    }
  }
}
.item-ctrl {
  text-align: left;
}
.checkbox-wrap {
  width: 30px;
}
</style>
